module.exports = __webpack_public_path__ + "static/media/screenshot(51).fe8f5c26.jpg";